import React, { useState, useEffect } from "react";
import ImageUploader from "../components/ImageUploader";
import { useSearchParams } from "react-router-dom";

const ImageUploaderPage = () => {
  const [searchParams] = useSearchParams();
  const getQueryParam = (key) => {
    return searchParams.get(key);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-400">
      {/* <div className="w-[90vw] h-[90vh]"> */}
      <div className="w-full h-screen">
        <ImageUploader siteId={getQueryParam("siteId")} eid= {getQueryParam("eid")} thumbnailsize= {getQueryParam("thumbnailsize")} pageId = {getQueryParam("pageId")} />
      </div>
    </div>
  );
};

export default ImageUploaderPage;